import { render, staticRenderFns } from "./po_board.vue?vue&type=template&id=776061d6&scoped=true"
import script from "./po_board.vue?vue&type=script&lang=js"
export * from "./po_board.vue?vue&type=script&lang=js"
import style0 from "./po_board.vue?vue&type=style&index=0&id=776061d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776061d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776061d6')) {
      api.createRecord('776061d6', component.options)
    } else {
      api.reload('776061d6', component.options)
    }
    module.hot.accept("./po_board.vue?vue&type=template&id=776061d6&scoped=true", function () {
      api.rerender('776061d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/boardManage/dataOperation/po_board.vue"
export default component.exports